export default "__VITE_ASSET__DFk$Vf5j__"